import { keyframes, styled } from "@mui/system";

export const slideDown = keyframes({
  from: {
    opacity: 0,
    transform: "translateY(-8px) scale(0.98)",
  },
  to: {
    opacity: 1,
    transform: "translateY(0) scale(1)",
  },
});

export const AdminLayoutWrapper = styled("div")(() => ({
  width: "100%",
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#f5f6fa",
}));
export const AdminHeader = styled("div")(() => ({
  height: 64,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 24px",
  backgroundColor: "#ffffff",
  borderBottom: "1px solid #e5e7eb",
}));

export const HeaderLogo = styled("div")(() => ({
  fontSize: 18,
  fontWeight: 700,
  color: "#2563eb",
}));

export const HeaderAdmin = styled("div")(() => ({
  fontSize: 14,
  fontWeight: 500,
  color: "#111827",
}));
export const AdminBody = styled("div")(() => ({
  flex: 1,
  display: "flex",
  overflow: "hidden",
}));
export const Sidebar = styled("div")(() => ({
  width: 240,
  backgroundColor: "#1f2937",
  color: "#ffffff",
  display: "flex",
  flexDirection: "column",
  padding: 16,
  "@media (max-width: 768px)": {
    display: "none",
  },
}));

export const SidebarMenu = styled("div")(() => ({
  marginTop: 24,
  display: "flex",
  flexDirection: "column",
  gap: 12,
}));

export const SidebarItem = styled("div")(() => ({
  padding: "10px 12px",
  borderRadius: 8,
  cursor: "pointer",
  fontSize: 14,
  transition: "0.2s",
  "&:hover": {
    backgroundColor: "#374151",
  },
}));
export const ContentWrapper = styled("div")(() => ({
  flex: 1,
  overflowY: "auto",
  backgroundColor: "#f9fafb",
  padding: "20px",
}));
export const DocumentNoteHeader = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 16,
}));

/* User menu */
export const UserMenuWrapper = styled("div")(() => ({
  position: "relative",
}));

export const UserTrigger = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  cursor: "pointer",
}));

export const DropdownMenu = styled("div")(() => ({
  position: "absolute",
  right: 0,
  top: "calc(100% + 8px)",
  minWidth: 180,

  backgroundColor: "#fff",
  borderRadius: 12,
  boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
  padding: "6px 0",

  animation: `${slideDown} 0.18s ease-out`,
  zIndex: 20,
}));

export const DropdownItem = styled("div")(() => ({
  padding: "10px 16px",
  fontSize: 14,
  cursor: "pointer",
  transition: "background-color 0.15s",
  color: "#000000",
  "&:hover": {
    backgroundColor: "#f5f5f5",
  },
  display: "flex",
  gap: "5px",
  alignItems: "center",
}));

export const DropdownItemLogout = styled("div")(() => ({
  padding: "10px 16px",
  fontSize: 14,
  cursor: "pointer",
  color: "#e53935",
  fontWeight: 500,
  transition: "background-color 0.15s",
  display: "flex",
  gap: "5px",
  alignItems: "center",
  "&:hover": {
    backgroundColor: "#fee2e2",
  },
}));

export const UserName = styled("span")(() => ({
  marginLeft: 8,
  fontSize: 14,
  fontWeight: 500,
}));

export const Avatar = styled("img")(() => ({
  width: 32,
  height: 32,
  borderRadius: "50%",
}));
